// Nav drawer, entire row clickable
document.addEventListener('DOMContentLoaded', () => {
  const firstLevelLinks = document.querySelectorAll('.mobile-navlink--level-1');
  const secondLevelLinks = document.querySelectorAll('.mobile-navlink--level-2');

  const handleClick = (e, level) => {
    const toggleButton = e.target.closest('li').querySelector(`.mobile-nav__trigger--level-${level}`);

    if (toggleButton) {
      e.preventDefault();
      toggleButton.click();
    } else {
      console.log('No toggle button found, default link behavior will proceed.');
    }
  };

  firstLevelLinks.forEach(link => {
    link.addEventListener('click', e => handleClick(e, 1));
  });

  secondLevelLinks.forEach(link => {
    link.addEventListener('click', e => handleClick(e, 2));
  });
});



// Size chart placement (robust for Größe / Weite / Länge)
document.addEventListener('DOMContentLoaded', () => {
  // Ziel-Begriffe normalisieren (Umlaute/ß werden abgefangen)
  const normalize = (s) =>
    (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')                 // diacritics trennen
      .replace(/[\u0300-\u036f]/g, '')  // diacritics entfernen
      .replace(/ß/g, 'ss')              // ß -> ss
      .trim();

  const TARGETS = new Set(['groesse','grosse','weite']);

  // Alle Fieldsets im Selector-Bereich suchen und Label-Text auslesen
  const fieldsets = [...document.querySelectorAll('.product__selectors fieldset')];
  const targetWrappers = [];

  fieldsets.forEach(fs => {
    const labelEl =
      fs.querySelector('.radio__legend .radio__legend__label-typography') ||
      fs.querySelector('.select__label') ||
      fs.querySelector('legend, label');
    const labelText = normalize(labelEl?.textContent);

    if (TARGETS.has(labelText)) {
      // Wrapper finden oder erzeugen (rechts neben dem Label)
      let wrapper = fs.querySelector('.fsr-size-label-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('span');
        wrapper.className = 'fsr-size-label-wrapper';
        // bevorzugt in die Legend einfügen, sonst ans Fieldset
        const legend = fs.querySelector('.radio__legend') || fs;
        legend.appendChild(wrapper);
      }
      targetWrappers.push(wrapper);
    }
  });

  // Falls keine passenden Optionen existieren, sauber beenden
  if (!targetWrappers.length) return;

  // Auf das Einfügen des Size-Chart-Buttons warten (wird von der Size-Chart-App injected)
  const observer = new MutationObserver(() => {
    const btn = document.querySelector('.scr-open-size-chart');
    if (!btn) return;

    // Observer beenden – Button ist da
    observer.disconnect();

    // Button in alle passenden Wrapper klonen/einfügen
    targetWrappers.forEach((wrapper, i) => {
      const clone = i === 0 ? btn : btn.cloneNode(true);
      wrapper.appendChild(clone);
      clone.style.display = 'inline-block';
    });

    // Optional: zusätzlich am Ende des "Passform"-Akkordeons einfügen
    const passform = document.querySelector('.product__accordion [data-accordion-title="Passform"]');
    if (passform) {
      const content = passform.nextElementSibling?.querySelector('.metafield-rich_text_field, .accordion__content, [data-scroll]');
      if (content) {
        const extra = btn.cloneNode(true);
        extra.style.display = 'block';
        extra.style.marginTop = '-10px';
        content.appendChild(extra);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


